import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
);
function BarChart({labels, values}) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };


  const data = {
    labels : labels,
    datasets: [
      {
        label: "سود",
        data: values,
        borderColor: "#809fff",
        backgroundColor: "#3366ff",
      }
    ]
  };
  return (
    <>
      <Bar options={options} data={data}/>
    </>
  );
}

export default BarChart;
